function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlohaaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.636,
    height: 94.691,
    viewBox: "0 0 162.636 94.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M608.421 668.651a5.693 5.693 0 0 1-5.565 6.889h-42.3a5.693 5.693 0 0 1-5.566-6.889 27.325 27.325 0 0 1 51.824-5.021 27.083 27.083 0 0 1 1.607 5.021zm-47.856-20.962a5.667 5.667 0 0 0 3.113-.93 32.945 32.945 0 0 1 36.061 0 5.692 5.692 0 1 0 6.236-9.524 44.332 44.332 0 0 0-48.534 0 5.693 5.693 0 0 0 3.124 10.456z",
    transform: "translate(-501.137 -630.002)",
    style: {
      fill: "#f8153b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M50.962 275.163h7.775v25.589h-7.775v-2.559c-.344.886-2.657 3.051-6.594 3.051-5.856 0-12.6-4.183-12.6-13.336 0-8.808 6.742-13.188 12.6-13.188a8.483 8.483 0 0 1 6.594 2.8zM45.5 294.4c3.2 0 5.807-2.214 5.807-6.5 0-4.134-2.608-6.348-5.807-6.348a5.977 5.977 0 0 0-6.2 6.348c0 4.24 2.853 6.5 6.2 6.5zm26.031-28.44v34.791h-7.775V265.96zm17.715 8.759c5.807 0 13.483 4.38 13.483 13.336 0 9.005-7.677 13.188-13.483 13.188s-13.483-4.183-13.483-13.188c0-8.955 7.677-13.335 13.483-13.335zm0 6.84c-2.953 0-5.954 2.264-5.954 6.5a5.99 5.99 0 1 0 11.958 0c0-4.236-3.05-6.499-6.004-6.499zm33.413-6.791c4.773 0 9.645 3.2 9.645 11.318v14.664h-7.775v-14.122c0-3.888-1.329-5.118-3.789-5.118-3.494 0-5.511 3.4-6 4.872v14.369h-7.775V265.96h7.775v13.631a8.846 8.846 0 0 1 7.919-4.822zm32.773.394h7.775v25.589h-7.775v-2.559c-.344.886-2.657 3.051-6.594 3.051-5.856 0-12.6-4.183-12.6-13.336 0-8.808 6.742-13.188 12.6-13.188a8.483 8.483 0 0 1 6.594 2.8zm-5.461 19.238c3.2 0 5.807-2.214 5.807-6.5 0-4.134-2.608-6.348-5.807-6.348a5.977 5.977 0 0 0-6.2 6.348c-.001 4.24 2.853 6.5 6.2 6.5zm36.661-19.241h7.775v25.589h-7.775v-2.559c-.344.886-2.657 3.051-6.594 3.051-5.856 0-12.6-4.183-12.6-13.336 0-8.808 6.742-13.188 12.6-13.188a8.483 8.483 0 0 1 6.594 2.8v-2.362zm-5.463 19.241c3.2 0 5.807-2.214 5.807-6.5 0-4.134-2.608-6.348-5.807-6.348a5.977 5.977 0 0 0-6.2 6.348c0 4.24 2.854 6.5 6.2 6.5z",
    transform: "translate(-31.77 -206.552)",
    style: {
      fill: "#f8153b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlohaaLogo);
export default __webpack_public_path__ + "static/media/alohaa_logo.82d59214d931e2730dd61932bfc3746a.svg";
export { ForwardRef as ReactComponent };